export const DEFAULT_CONTAINER_CLASSES = {
    'columns': true,
    'is-multiline': true
}

export const DEFAULT_ADVANCED_CONTAINER_CLASSES = {
  'columns': true,
  'is-align-items-flex-start': true,
  'is-multiline': true,
  'is-advanced-filter-box': true
}

/**
 * Modelo de objeto para configuração do componente de filtro;
 * @class ConfigFiltro
 * @namespace ConfigFiltro
 */
 export class ConfigFiltro {
  /**
   * Modelo do objeto de configuração do componente de filtro
   * @param {ContainerOptions} containerOptions - Objecto de configuração do container
   * @param {Array<ConfigCampoFiltro | Object>} options - Array de configurações de filtros
   * @param {ContainerOptions | null} advancedContainerOptions - Objecto de configuração do container de filtros avançados
   * @param {Array<ConfigCampoFiltro | Object>} advancedOptions - Array de configurações de filtros avançados
   */
  constructor(containerOptions = new ContainerOptions(), options = [], advancedContainerOptions = new ContainerOptions(DEFAULT_ADVANCED_CONTAINER_CLASSES), advancedOptions = []) {
    this.containerOptions = containerOptions;
    this.options = options;
    this.advancedContainerOptions = advancedContainerOptions;
    this.advancedOptions = advancedOptions;
  }
}

/**
 * Modelo de objeto de opções do container de filtro;
 * @class ContainerOptions
 * @namespace ContainerOptions
 */
 export class ContainerOptions {
  /**
   * Modelo do objeto de configuração do container do filtro
   * @param {String | Object} containerClasses - Classes css dinâmicas para adicionar ao container
   * @param {String | Object} containerStyles - Styles para adicionar ao container
   */
  constructor(containerClasses = {...DEFAULT_CONTAINER_CLASSES}, containerStyles = '') {
    this.containerClasses = containerClasses;
    this.containerStyles = containerStyles;
  }
}
